import {createEntityAdapter, EntityAdapter, EntityState} from '@ngrx/entity';
import * as CountriesActions from '../actions/countries.actions';
import {Country} from '../model/country';
import {createReducer, on} from '@ngrx/store';

export interface CountriesState extends EntityState<Country> {
    isPending: boolean;
}

export const adapter: EntityAdapter<Country> = createEntityAdapter<Country>({
    selectId: (attribute: Country) => attribute.iso2Code,
    sortComparer: false
});

export const initialState: CountriesState = adapter.getInitialState({
    isPending: false
});

export const reducer = createReducer(
    initialState,
    on(CountriesActions.loadCountries, state => ({...state, isPending: true})),
    on(CountriesActions.loadCountriesSuccess, (state, {countries}) => {
        return adapter.addMany(countries, {
            ...state,
            isPending: false
        });
    }),
    on(CountriesActions.loadCountriesFailure, state => ({...state, isPending: false}))
);

export const getIsPending = (state: CountriesState) => state.isPending;
